import { useCallback, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useReactToPrint } from 'react-to-print';
import { PrintButton, PrintSpin } from '../index';

export interface Prop {
  isPrintLading: boolean;
  children?: React.ReactNode;
}

export default function WindowPrint({ children, isPrintLading }: Prop) {
  const { t } = useTranslation();
  const printRef = useRef<HTMLDivElement>(null);

  const reactToPrintFn = useReactToPrint({
    contentRef: printRef,
  });

  const handleOnClick = useCallback(() => {
    reactToPrintFn();
  }, [reactToPrintFn]);

  useEffect(() => {
    if (isPrintLading) {
      handleOnClick();
    }
  }, [isPrintLading, handleOnClick]);

  return isPrintLading ? (
    <>
      <div className="text-center mt-4 flex justify-center gap-4">
        <PrintButton disabled={false} onClick={() => handleOnClick()} />
        <Button
          onClick={() => window.close()}
          icon={<CloseOutlined style={{ fontSize: 15 }} />}
        >
          {t('Close')}
        </Button>
      </div>
      <div ref={printRef}>{children}</div>
    </>
  ) : (
    <PrintSpin />
  );
}
